import React from "react";
import { connect } from "react-redux";

import * as router from "react-router-redux";
import { sessionActions } from "../modules/session";
import * as notifications from "../modules/notifications/actions";
import * as tracker from "../modules/tracker/actions";
import { AuthEvents } from "../modules/tracker/event-names";

function getQueryStringValue(key) {
    return decodeURIComponent(
        window.location.search.replace(
            new RegExp(
                "^(?:.*[&\\?]" +
                    encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
                    "(?:\\=([^&]*))?)?.*$",
                "i"
            ),
            "$1"
        )
    );
}

class LoginWithTokenContainer extends React.PureComponent {
    componentDidMount() {
        const maybeToken = getQueryStringValue("token");
        if (!maybeToken) {
            this.navigateTo("/");
        }
        this.props.authorizeUserWithToken(maybeToken).then(action => {
            const error = action.errorMessage;
            if (error) {
                this.props.trackEvent(AuthEvents.DID_FAIL_AUTHENTICATION, {
                    reason: error
                });
                this.props.notifyError(
                    "Sorry, we didn’t recognize that token."
                );
            } else {
                const redirect =
                    this.props.redirectAfterLogin ||
                    `/team/${action.session.teamId}/dashboard`;
                this.props.trackEvent(AuthEvents.DID_AUTHENTICATE_SUCCESSFULLY);
                this.props.navigateTo(redirect);
            }
        });
    }
    render = () => {
        return <div>redirecting...</div>;
    };
}

function mapStateToProps(state) {
    return {
        session: state.session
    };
}

function mapDispatchToProps(dispatch) {
    return {
        navigateTo: path => dispatch(router.replace(path)),
        authorizeUserWithToken: token =>
            dispatch(sessionActions.authorizeUserWithToken(token)),
        notifyError: errorMessage =>
            dispatch(notifications.notifyError(errorMessage)),
        trackEvent: (eventName, eventProperties) =>
            dispatch(tracker.trackEvent(eventName, eventProperties))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginWithTokenContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginWithTokenContainer.js